import React, { Component } from 'react'
import { connect } from 'react-redux'
import { client } from '../../utils/ApolloClient'
import { setCoupon } from '../../utils/store'
import GET_PRICE_WITH_COUPON from 'graphql/queries/getPriceWithCoupon'
import './CouponCode.css'
import { getUrlParameter } from '../../utils/filters'

class CouponCode extends Component {
  constructor(props) {
    super(props)

    this.state = {
      input: "",
      error: null,
      loading: false,
    }

    this.getPrice = this.getPrice.bind(this)
  }

  componentDidMount() {
    const prefilled = getUrlParameter(window.location.search, 'option[coupon]')
    if (prefilled) {
      this.setState({
        input: prefilled,
      }, this.apply)
    }
  }

  async apply() {
    if (!this.state.input) {
      return
    }

    this.setState({ loading: true })

    const { duration, serviceId } = this.props.booking

    try {
      const coupon = await client.query({
        query: GET_PRICE_WITH_COUPON,
        variables: {
          serviceId,
          duration,
          code: this.state.input,
        },
        fetchPolicy: 'network-only',
      }).then(r => r.data && r.data.coupon)
      if (!coupon.isValid) {
        throw new Error(coupon.message)
      }

      this.props.dispatch(setCoupon(coupon))
      return this.setState({ error: null, loading: false })
    } catch(error) {
      this.props.dispatch(setCoupon(null))
      return this.setState({
        error: error.message,
        loading: false,
      }, () => {
        setTimeout(() => {
          this.setState({ error: null })
        }, 2000)
      })
    }
  }

  remove() {
    this.props.dispatch(setCoupon(null))
  }

  handleInputChange(e) {
    this.setState({
      input: e.target.value,
    })
  }

  handleKeyUp(e){
    if (e.keyCode === 13) {
      e.preventDefault()
      this.apply()
    }
  }

  getPrice() {
    const service = this.props.business.services.find(s => s.id === this.props.booking.serviceId)
    const duration = service.durations && service.durations.find(d => d.duration === this.props.booking.duration)

    return duration ? duration.price : 0
  }

  renderForm() {
    if (this.props.coupon) {
      return null
    }

    let title = "Do you have a promo code?"
    if (this.props.business.bookingTemplatesHtml && this.props.business.bookingTemplatesHtml['coupon']) {
      title = this.props.business.bookingTemplatesHtml['coupon']
    }

    return (
      <div>
        <small dangerouslySetInnerHTML={{ __html: title }} />
        <div className="coupon-input">
          <input id="coupon-code" type="text" className="form-control" placeholder="Coupon code" value={this.state.input} onChange={this.handleInputChange.bind(this)} disabled={this.props.coupon !== null} onKeyUp={this.handleKeyUp.bind(this)} />
          <button onClick={this.apply.bind(this)} disabled={!this.state.input || this.state.loading}><i className={ this.state.loading ? 'fa fa-gear fa-spin' : 'fa fa-check' } /></button>
        </div>
        { this.state.error && <span className="error">{ this.state.error }</span> }
      </div>
    )
  }

  renderCoupon() {
    const { coupon } = this.props
    if (!coupon) {
      return null
    }

    return (
      <div className="coupon-details">
        <span className="code">Coupon <em>{ coupon.code }</em> applied</span>
        <button className="fa fa-trash" onClick={this.remove.bind(this)}></button>
      </div>
    )
  }

  render() {
    if (!this.props.business || !this.props.business.hasCoupons || this.getPrice() <= 0) {
      return null
    }

    return (
      <div className="coupon-code">
        { this.renderForm() }
        { this.renderCoupon() }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  coupon: state.coupon,
})
export default connect(mapStateToProps)(CouponCode)
